import { allChangelogs } from "content-collections";

export const changelogsByVersion = [...allChangelogs].reduce(
	(acc, changelog) => {
		if (!acc[changelog.version]) {
			acc[changelog.version] = [];
		}
		acc[changelog.version].push(changelog);
		return acc;
	},
	{} as Record<string, typeof allChangelogs>,
);

export const sortedVersionsNewestFirst = Object.keys(changelogsByVersion).sort(
	(a, b) => {
		const versionA = a.split(".").map(Number);
		const versionB = b.split(".").map(Number);

		for (let i = 0; i < Math.max(versionA.length, versionB.length); i++) {
			const numA = versionA[i] || 0;
			const numB = versionB[i] || 0;
			if (numA !== numB) {
				return numB - numA; // Sort in descending order (newest first)
			}
		}
		return 0;
	},
);

export const sortedVersionsOldestFirst = Object.keys(changelogsByVersion).sort(
	(a, b) => {
		const versionA = a.split(".").map(Number);
		const versionB = b.split(".").map(Number);

		for (let i = 0; i < Math.max(versionA.length, versionB.length); i++) {
			const numA = versionA[i] || 0;
			const numB = versionB[i] || 0;
			if (numA !== numB) {
				return numA - numB; // Sort in descending order (newest first)
			}
		}
		return 0;
	},
);
